import { TIMELINE_START } from "../Timeline";

export function IndicatorACreated() {
  return <circle r="6" cx="10" cy={TIMELINE_START} className="active" />;
}
